module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre3"
  }, [_vm._v("[Personen]")]), _vm._v(" "), _c('table', {
    staticClass: "center1",
    attrs: {
      "cellpadding": "5",
      "cellspacing": "0",
      "width": "60%"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "calibre4"
  }, [_c('td', {
    staticClass: "calibre5"
  }, [_c('h4', {
    staticClass: "calibre6 sigil_not_in_toc"
  }, [_vm._v("Personen des Vorspiels:")]), _vm._v(" "), _c('dl', {
    staticClass: "calibre7"
  }, [_c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Peter Saburoff,")]), _vm._v(" "), _c('dd', {
    staticClass: "calibre9"
  }, [_vm._v("Schankwirt.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Vera Saburoff,")]), _vm._v(" "), _c('dd', {
    staticClass: "calibre9"
  }, [_vm._v("seine Tochter.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Michael, .")]), _vm._v(" "), _c('dd', {
    staticClass: "calibre9"
  }, [_vm._v("ein Bauer")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Oberst Kotemkin.")])]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Ort der Handlung: Rußland. Zeit: 1795.")]), _vm._v(" "), _c('h4', {
    staticClass: "calibre6 sigil_not_in_toc"
  }, [_vm._v("Personen des Stückes:")]), _vm._v(" "), _c('dl', {
    staticClass: "calibre7"
  }, [_c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Zar Iwan.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Fürst Paul Maraloffski,")]), _vm._v(" "), _c('dd', {
    staticClass: "calibre9"
  }, [_vm._v("Premierminister in Rußland.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Fürst Petrowitsch.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Graf Ruvaloff.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Baron Raff.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Marquis de Poivrard.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("General Kotemkin")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Ein Page.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Nihilisten:")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Peter Tschernawitsch,")]), _vm._v(" "), _c('dd', {
    staticClass: "calibre9"
  }, [_vm._v("Präsident der Nihilistenvereinigung.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Michael.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Alexis Iwantschiewitsch,")]), _vm._v(" "), _c('dd', {
    staticClass: "calibre9"
  }, [_vm._v("angeblich Student der Medizin.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Professor Marfa.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Vera Saburoff.")]), _vm._v(" "), _c('dt', {
    staticClass: "calibre8"
  }, [_vm._v("Soldaten, Verschwörer usw.")])]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Ort der Handlung: Moskau. Zeit: 1800. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page4",
      "title": "auguste64/DaoH"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page5",
      "title": "divisi/KaFa"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e22bcf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter1.vue
// module id = 60
// module chunks = 0